import AuthService, {IAPIResponse} from './AuthService';
import {PublicHolidayModel} from '../PublicHolidays/PublicHoliday.Model';

class PublicHolidayService extends AuthService {
	public savePublicHoliday(publicHoliday: PublicHolidayModel): Promise<void> {
		return this.fetch(`/api/publicHolidays/${publicHoliday._id ?? 'new'}`, {
			method: 'POST',
			body: JSON.stringify(publicHoliday),
		});
	}

	public async getAllPublicHolidays(): Promise<PublicHolidayModel[]> {
		const result = await this.fetch<IAPIResponse<PublicHolidayModel[]>>(
			'/api/publicHolidays/',
			{
				method: 'GET',
			}
		);

		if (!result.success || result.message) {
			throw new Error(result.message);
		}

		if (result.success && result.data) {
			return result.data;
		}

		return [];
	}

	public deletePublicHoliday(
		publicHoliday: PublicHolidayModel
	): Promise<void> {
		if (!publicHoliday._id) {
			throw new Error('No public holiday was specified');
		}
		return this.fetch(`/api/publicHolidays/${publicHoliday._id}`, {
			method: 'DELETE',
		});
	}
}

export default PublicHolidayService;
